import { createSlice } from "@reduxjs/toolkit";

import { LOCAL_STORAGE_KEYS } from "../../Util/constants";

// import { v4 as uuidv4 } from "uuid";

// const session = localStorage.getItem(LOCAL_STORAGE_KEYS.SESSION_TOKEN);
const initialState = {
  organization: 'Newsie, LLC',
  profile: {},
  puzzles: []
};
export const clientProfileSlice = createSlice({
  name: LOCAL_STORAGE_KEYS.CLIENT_PROFILE,
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.puzzles = action?.payload?.puzzles
      state.profile = action?.payload?.user
    }
  },
});


// Action creators are generated for each case reducer function
export const {
  setProfile
} = clientProfileSlice.actions;

export default clientProfileSlice.reducer;
